(function($){

    $('.assign-to-remove').on('click', function(){
        var atr_click = false, elements = 0;
        $('.assign-to-remove').each(function(){
            if($(this).prop('checked') === true){
                atr_click = true;
                elements++;
            }
        })
        $('.room-tasks a').html($('.room-tasks a').attr('data-title') + ' ('+elements+')');
        if(atr_click){
            $('.room-tasks').slideDown(500);
        }
        else{
            $('.room-tasks').slideUp(500);
        }
    })

    $('.remove-rooms').on('click', function(e){
        e.preventDefault();
        bootbox.confirm({
            message: 'Czy na pewno chcesz usunąć pokoje?',
            buttons: {
                confirm: {
                    label: 'Tak',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Nie',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result === true) {
                    $('.assign-to-remove').each(function(){
                        if($(this).prop('checked') === true){
                            remove_room($(this).val());
                        }
                    })
                }
            }
        });
    })

    //acf-form-ajax
    $('body').on('click', '.remove-room, .delete-single-room', function(e){
        e.preventDefault();
        if (confirm('Czy na pewno chcesz usunąć?')) {
            remove_room($(this).attr('data-id'));
        }
    });
    $('.resort-select ul li').on('click', function(){
        $('.resort-select select').val($(this).attr('data-value')).trigger('change');
        $(this).closest('ul').slideUp(500);
        $('.resort-select select').slideDown(500);
    })
    $('body').on('click', '.duplicate-room', function(e){
        e.preventDefault();
        duplicate_room($(this).attr('data-id'));
    });

    $('body').on('click', '.show-equipment-edit', function(){
       $(this).next('.equipment-edit').fadeToggle(500);
    });
    $('body').on('click', '.show-pricing-edit', function(){
        $(this).next('.pricing-edit').fadeToggle(500);
    });
    if($('#set-resort-for-room-edit').length > 0) {
        $('#set-resort-for-room-edit').on('change', function () {
            if (history.pushState) {
                history.pushState(null, null, '#' + $('#set-resort-for-room-edit').val());
            } else {
                location.hash = '#' + $('#set-resort-for-room-edit').val();
            }
            $('.resort-container select').val($(this).val());
            rooms_by_resort($(this).val());
            $('.custom-button').remove();
            $('<div class="acf-field custom-button"><button type="submit" class="btn btn-success">Dodaj pokój »</button></div>').insertAfter('#new-room .acf-field--validate-email')
        });
        $(document).ready(function(){
            if(window.location.hash){
                $('.resort-select ul').slideUp(500);
                $('.resort-select select').slideDown(500);
                var room = window.location.hash.replace('#', '');
                $('#set-resort-for-room-edit').val(room).trigger('change');
                // rooms_by_resort(room);
            }
        });
        $('body').on('click', '.show-form-room', function(e){
            e.preventDefault();
            $('.room-form').fadeIn(500);
            $(this).closest('tfoot').fadeOut(500);
            $('[data-name="numer_pokoju"]').width($('.table-rooms thead tr th:nth-child(1)').width()-7);
            $('[data-name="pietro"]').width($('.table-rooms thead tr th:nth-child(2)').width()-7);
            $('[data-name="strona"]').width($('.table-rooms thead tr th:nth-child(3)').width()-7);
            $('[data-name="balkon"]').width($('.table-rooms thead tr th:nth-child(4)').width()-7);
            $('[data-name="rodzaj"]').width($('.table-rooms thead tr th:nth-child(5)').width()-7);
            $('[data-name="dla_niepelnosprawnych"]').width($('.table-rooms thead tr th:nth-child(6)').width()-7);
            $('[data-name="wyposazenie"]').width($('.table-rooms thead tr th:nth-child(7)').width()-7);
            $('[data-name="cennik"]').width($('.table-rooms thead tr th:nth-child(8)').width()-7);
            $('[data-name="uwagi"]').width($('.table-rooms thead tr th:nth-child(9)').width()-7);
        });
    }

})(jQuery);